<template>
  <div class="nav-bar">
    <div v-show="leftShow === 'true'" class="btn left" @click="leftClick">{{leftName}}</div>
    <div v-show="rightShow === 'true'" class="btn right" @click="rigthClick">{{rightName}}</div>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  props: {
    leftName: {
      type: String,
      default: '返回'
    },
    rightName: {
      type: String,
      default: '保存'
    },
    rightShow: {
      type: String,
      default: 'true'
    },
    leftShow: {
      type: String,
      default: 'true'
    }
  },
  methods: {
    rigthClick () {
      this.$emit('rightClick', '')
    },
    leftClick () {
      this.$emit('leftClick', '')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~styles/mixins.styl"
.nav-bar
  height 40px;
  width 100%;
  background #ffffff;
  line-height 40px;
  rowSpaceBetween()
  .btn
    font-size 16px;
    color #333333;
    padding 0 17px;
    text-align center;
</style>


// WEBPACK FOOTER //
// src/components/NavBar/NavBar.vue